import React, { useMemo } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';
import './styles.scss';

const PasswordValidation = ({ password = '' }) => {
  const validations = useMemo(() => {
    const minLength = password.length >= 8;
    const hasUpperCase = /[A-Z]/.test(password);
    const hasLowerCase = /[a-z]/.test(password);
    const hasNumber = /[0-9]/.test(password);
    const hasSpecialChar = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(password);

    return [
      {
        id: 'minLength',
        label: 'Mínimo 8 caracteres',
        isValid: minLength,
      },
      {
        id: 'hasUpperCase',
        label: 'Deve conter letra maiúscula',
        isValid: hasUpperCase,
      },
      {
        id: 'hasLowerCase',
        label: 'Deve conter letra minúscula',
        isValid: hasLowerCase,
      },
      {
        id: 'hasNumber',
        label: 'Deve conter número',
        isValid: hasNumber,
      },
      {
        id: 'hasSpecialChar',
        label: 'Deve conter caractere especial',
        isValid: hasSpecialChar,
      },
    ];
  }, [password]);

  return (
    <div className="password-validation">
      <ul className="password-validation-list">
        {validations.map((validation) => (
          <li
            key={validation.id}
            className={`password-validation-item ${
              validation.isValid ? 'valid' : 'invalid'
            }`}
          >
            <FontAwesomeIcon
              icon={validation.isValid ? faCheck : faTimes}
              className="password-validation-icon"
            />
            <span className="password-validation-label">
              {validation.label}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default PasswordValidation;
